import e from"styled-components";import{theme as i}from"../../../../../theme.js";const t=e.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${i.spacing*4}px;
  background-color: ${({active:r})=>r?i.colors.success[50]:i.colors.gray[100]};
  border-radius: ${i.radius}px;
  cursor: pointer;
  .client {
    display: grid;
    grid-template-columns: 40px 1fr;
    gap: ${i.spacing*2}px;
    align-items: center;
    > span {
      font-size: 14px;
      line-height: 24px;
      color: ${i.colors.gray[800]};
      font-weight: 700;
    }
  }
  > svg {
    width: 24px;
    height: 24px;
    > g,
    path {
      fill: ${i.colors.primary[500]};
    }
  }
`,o=e.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${i.colors.gray[200]};
  > svg {
    width: 24px;
    height: 24px;
    > g,
    path {
      fill: ${i.colors.gray[400]};
    }
  }
  > img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
  }
`;export{t as ClientContanier,o as ClientPicture};
